export function ManifestFile() {
    return <link rel="manifest" href="/manifest.json" crossOrigin="use-credentials" />;
}
